import { Icon } from 'bold-ui'
import { useErrorHandler } from 'components/error'
import { useFirebase } from 'hooks/firebase/useFirebase'
import React from 'react'
import { EventoAgendaLotacao } from 'view/agenda/model-agenda'

import { useImpressaoComprovanteAgendamento } from '../../impressao/useImpressaoAgendamentos'
import MenuAcoesAgendamentoButton from '../MenuAcoesAgendamentoButton'
import { AcaoAgendamentoButtonProps } from '../model-acoesAgendamento'

interface ImprimirAgendamentoButtonProps extends Omit<AcaoAgendamentoButtonProps, 'event'> {
  event: Pick<EventoAgendaLotacao, 'id' | 'nomeCidadao'>
}

export function ImprimirAgendamentoButton(props: Readonly<ImprimirAgendamentoButtonProps>) {
  const { event, disabled, tooltip, isDropdown = false } = props

  const { analytics } = useFirebase()
  const handleError = useErrorHandler()
  const { handleImpressaoComprovanteAgendamento } = useImpressaoComprovanteAgendamento()

  const handleClickImprimirAgendamento = () => {
    analytics.logEvent('impressao_agendamento_cidadao')
    return handleImpressaoComprovanteAgendamento(event.nomeCidadao, event.id).catch(handleError)
  }

  return (
    <MenuAcoesAgendamentoButton
      text='Imprimir agendamento'
      disabled={disabled}
      tooltip={tooltip}
      isDropdown={isDropdown}
      onClick={handleClickImprimirAgendamento}
      icon={<Icon icon='printerOutline' />}
    />
  )
}
